import * as React from 'react';
import * as main from '../../main.module.scss';
import * as revs from "./style.module.scss";
import { Modal } from "../../../../Modal";
export const Revs = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={revs.revs}>
      <div className="container">
        <div className={revs.container}>
          <div className={revs.block}>
            <h2 className={main.title}>Ученики об Advance</h2>
            <ul>
              <li>
                <iframe
                  title={'Прошла программу 8 класса за 2 недели! Личный опыт экстерна Анастасии Лещевой'}
                  allow="autoplay; encrypted-media"
                  src="https://65395.servicecdn.ru/videos/65395_P4gCoi1XHZHpBoTF"
                  allowFullScreen
                />
              </li>
              <li>
                <iframe
                  title={'Силина Настя'}
                  allow="autoplay; encrypted-media"
                  src="https://65395.servicecdn.ru/videos/65395_z4ldx2OwKYX12IN"
                  allowFullScreen
                />
              </li>
              <li>
                <iframe
                  title={'Отзыв'}
                  allow="autoplay; encrypted-media"
                  src="https://65395.servicecdn.ru/videos/65395_EpqBixgJGO1dhwZz"
                  allowFullScreen
                />
              </li>
            </ul>
            <button className={main.btn} onClick={()=>{setShowModal(true)}}>Зарегистрироваться бесплатно</button>
          </div>
          <div className={revs.block}>
            <h2 className={main.title}>Родители об Advance</h2>
            <ul>
              <li>
                <iframe
                  title={'Радислав Гандапас - отзыв об обучении в Advance и об обучении его сына'}
                  allow="autoplay; encrypted-media"
                  src="https://65395.servicecdn.ru/videos/65395_0AG7RkCBdMzLiXh"
                  allowFullScreen
                />
              </li>
              <li>
                <iframe
                  title={'Папа предприниматель, а дочь олимпиадница: отзыв Александра Коновалова через 8 лет после курса'}
                  allow="autoplay; encrypted-media"
                  src="https://65395.servicecdn.ru/videos/65395_n5OqzstHZWm3pba4"
                  allowFullScreen
                />
              </li>
              <li>
                <iframe
                  title={'Отзыв Инны и Марка Толстовых'}
                  allow="autoplay; encrypted-media"
                  src="https://65395.servicecdn.ru/videos/65395_KpaIBPk6vO417gh"
                  allowFullScreen
                />
              </li>
            </ul>
            <button className={main.btn} onClick={()=>{setShowModal(true)}}>Зарегистрироваться бесплатно</button>
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
}
